import { arrayMove } from '@dnd-kit/sortable'

/**
 * Calcul PUR du réordonnancement d'une liste de colonnes actives après un
 * glisser-déposer `@dnd-kit`.
 *
 * Vit dans son propre fichier (et pas dans ColumnsPicker.jsx) pour la même
 * raison que `boardMove.js` : un export non-composant depuis un `.jsx` casse
 * le Fast Refresh de Vite (règle eslint `react-refresh/only-export-components`).
 *
 * `ColumnsPicker` donne à chaque ligne un id `col-<index>` (position pure,
 * pas la clé de colonne — deux colonnes ne partagent jamais de position) ;
 * cette fonction n'a donc besoin que de ces deux ids pour retrouver les
 * index déplacés, sans dépendre du tableau `ids` complet.
 *
 * @param {string[]} active   les clés de colonnes actives, dans leur ordre actuel.
 * @param {string}   activeId l'id `col-<index>` de la ligne saisie.
 * @param {string}   overId   l'id `col-<index>` de la ligne survolée au lâcher.
 *
 * @returns {string[]|null} le tableau réordonné, ou `null` quand il n'y a rien
 *   à faire (lâché hors zone, lâché sur soi-même, id hors plage).
 */
export function columnsAfterDrag(active, activeId, overId) {
  if (!Array.isArray(active) || !overId || activeId === overId) return null
  const oldIndex = indexFromId(activeId, active.length)
  const newIndex = indexFromId(overId, active.length)
  if (oldIndex === null || newIndex === null) return null
  return arrayMove(active, oldIndex, newIndex)
}

function indexFromId(id, length) {
  const match = typeof id === 'string' && /^col-(\d+)$/.exec(id)
  if (!match) return null
  const index = Number(match[1])
  return index >= 0 && index < length ? index : null
}
